export default "/assets/images/critter-cuddler1.c1cc007a8f2e2522.png";